import { Button, CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { manage_booking_api } from "src/DAL/HelpingVideos/AdminHelpingVideosCategory";
import { makeStyles } from "@mui/styles";
import RecordNotFound from "src/components/GeneralComponents/RecordNotFound";
import { s3baseUrl } from "src/config/config";
import { useQuery } from "@tanstack/react-query";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function RedirectPage() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const { data: mangeBooking = [], isLoading } = useQuery({
    queryKey: ["manageBooking"],
    queryFn: async () => {
      const result = await manage_booking_api();
      if (result?.code !== 200) {
        throw new Error(result?.message);
      }
      return result;
    },
    select: (result) => result?.booking_information || [],
    onError: (error) => {
      enqueueSnackbar(error?.message, { variant: "error" });
    },
  });

  const handleRedirect = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <h2>Booking</h2>
        </div>
        {mangeBooking.length > 0 ? (
          mangeBooking.map((value, index) => {
            return (
              <div className="col-lg-4 col-md-4 col-sm-12 mb-4" key={index}>
                <div
                  className="card mt-4 pods-cards-shadow cursor h-100"
                  onClick={() => handleRedirect(value?.redirect_url)}
                >
                  <img
                    src={s3baseUrl + value?.image?.thumbnail_1}
                    className="card-img-top pods-image"
                    alt="Programme"
                  />
                  <div className="card-body text-start position-relative">
                    <h3 className="h2-heading">{value.title}</h3>
                    <p className="text-muted mb-0">{value.program}</p>
                    <p className="programme-card-desc py-2">
                      {value.description}
                    </p>
                    <div className="d-flex justify-content-end position-absolute bottom-0 end-0 p-3">
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => handleRedirect(value?.redirect_url)}
                      >
                        Open Booking Page
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <RecordNotFound title="Data Not Found" />
        )}
      </div>
    </div>
  );
}
